import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';

export default function NotFound() {
    return (
        <div className='generalContainer'>
            <h3 className='page-heading'>Page Not Found</h3>
            <div className='about-page'>
                <p className='about_text'>
                    Sorry, that page doesn't exist. <Link to='/'>Go back home</Link>.
                </p>
            </div>
        </div>
    );
}
